import * as React from "react";
function SvgTriangleBarLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M27 32L11 16 27 0v32z" />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={4}
        d="M7 32V0"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTriangleBarLeft);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
